import script from "./quickPresets.vue?vue&type=script&setup=true&lang=js"
export * from "./quickPresets.vue?vue&type=script&setup=true&lang=js"

import "./quickPresets.vue?vue&type=style&index=0&id=4417c83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4417c83e"]])

export default __exports__